import { ClientItemId, getUserMailboxInfo } from 'owa-client-ids';
import { ClientItem } from 'owa-mail-store';
import { loadItem } from 'owa-mail-store-actions';

const getItemWithNormalizedBody = (itemId: string): Promise<ClientItem> => {
    const clientItemId: ClientItemId = {
        Id: itemId,
        mailboxInfo: getUserMailboxInfo(),
    };
    return loadItem(clientItemId, 'LoadForSmimeResponse');
};

export default getItemWithNormalizedBody;
